import { render } from "./MathGuideline.vue?vue&type=template&id=e137a16e&scoped=true"
import script from "./MathGuideline.vue?vue&type=script&lang=js"
export * from "./MathGuideline.vue?vue&type=script&lang=js"

import "./MathGuideline.vue?vue&type=style&index=0&id=e137a16e&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e137a16e"]])

export default __exports__